import { render, staticRenderFns } from "./viewFixedPurchase.vue?vue&type=template&id=06bb357e&scoped=true&"
import script from "./viewFixedPurchase.vue?vue&type=script&lang=js&"
export * from "./viewFixedPurchase.vue?vue&type=script&lang=js&"
import style0 from "./viewFixedPurchase.vue?vue&type=style&index=0&id=06bb357e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb357e",
  null
  
)

export default component.exports